<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from '../provider.js';
import BaseBubble from './Base.vue';

const { content, contentAttributes } = useMessageContext();

const { t } = useI18n();

// Mirrors the backend default in Whatsapp::Providers::BaseService#flow_parameters.
const ctaLabel = computed(
  () =>
    contentAttributes.value?.flowCta ||
    contentAttributes.value?.flow_cta ||
    t('WHATSAPP_INTERACTIVE.FLOW.CTA_PLACEHOLDER')
);
</script>

<template>
  <BaseBubble class="p-3 flex flex-col gap-2" data-bubble-name="whatsapp-flow">
    <p v-if="content" class="text-sm whitespace-pre-wrap text-n-slate-12">
      {{ content }}
    </p>
    <div
      class="px-3 py-2 text-sm font-medium text-center rounded-lg text-n-blue-11 bg-n-alpha-black2"
    >
      {{ ctaLabel }}
    </div>
  </BaseBubble>
</template>
